module.exports = __webpack_public_path__ + "img/mobile_driving.c1de0dbd.svg";